import { Controller } from "stimulus"

export default class extends Controller {

	static targets = ["notificationEmailField"]

	close() {
		this.element.classList.remove('is-active')
	}

	async submit() {
		const data = this.element.dataset

		const notification_email = this.notificationEmailFieldTarget.value
		// post to server
		const response = await fetch('/customers/availability_requests', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-TOKEN': document.querySelector( 'meta[name="csrf-token"]' ).getAttribute("content")
			},
			body: JSON.stringify({
				availability_request: {
					orderable_id: data.itemId,
					// TODO: handle when not Session, Meeting
					orderable_type: data.itemType,
					notification_email: notification_email
				}
			})
		})
		Turbolinks.visit(window.location)
		console.log(response)
	}

	async delete() {
		const self = this;

		const response = await fetch("/customers/availability_requests", {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-TOKEN': document.querySelector( 'meta[name="csrf-token"]' ).getAttribute("content")
			},
			body: JSON.stringify({
				orderable_id: self.element.dataset.itemId,
				orderable_type: self.element.dataset.itemType
			})
		})
		Turbolinks.visit(window.location)
		console.log(response)
	}

	connect() {
	}
}
